interface TomSelectWithDom {
  wrapper?: HTMLElement | null
  control?: HTMLElement | null
}

export function decorateTomSelectWithDataCy (
  element: HTMLElement,
  plugin: TomSelectWithDom
): void {
  const baseCy = element.dataset.cy

  if (baseCy == null || baseCy === '') return

  if (plugin.wrapper != null) plugin.wrapper.dataset.cy = `${baseCy}-wrapper`
  if (plugin.control != null) plugin.control.dataset.cy = `${baseCy}-control`
}
